import i18next from 'i18next';
import { RangeTypes } from 'infrastructure/enums';

export interface IRangeTypeItem {
  id: RangeTypes;
  name: string;
  interval: 'day' | 'hour';
}

export const rangeTypesDataSource = (): IRangeTypeItem[] => {
  return [
    {
      id: RangeTypes.Custom,
      name: i18next.t('rangeTypes.custom'),
      interval: 'day',
    },
    {
      id: RangeTypes.Daily,
      name: i18next.t('rangeTypes.daily'),
      interval: 'hour',
    },
    {
      id: RangeTypes.Weekly,
      name: i18next.t('rangeTypes.weekly'),
      interval: 'day',
    },
    {
      id: RangeTypes.Monthly,
      name: i18next.t('rangeTypes.monthly'),
      interval: 'day',
    },
  ];
};
